import {
  RichTextField,
  SimpleShowLayout,
  TextField,
  TextInput,
  Show,
  SimpleForm,
} from "react-admin";
export default function ArtistShow(props) {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="url" />
        <RichTextField source="description" />
      </SimpleShowLayout>
    </Show>
  );
}
